// @generated by protobuf-ts 2.11.1
// @generated from protobuf file "imports.proto" (package "imports", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message imports.Import
 */
export interface Import {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: uint32 account = 2
     */
    account: number;
    /**
     * @generated from protobuf field: string file_name = 3
     */
    fileName: string;
    /**
     * @generated from protobuf field: uint32 row_count = 4
     */
    rowCount: number;
    /**
     * @generated from protobuf field: string created_at = 5
     */
    createdAt: string;
}
/**
 * @generated from protobuf message imports.StartImportRequest
 */
export interface StartImportRequest {
    /**
     * @generated from protobuf field: uint32 account = 1
     */
    account: number;
    /**
     * @generated from protobuf field: string file_name = 2
     */
    fileName: string;
}
/**
 * @generated from protobuf message imports.StartImportResponse
 */
export interface StartImportResponse {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
}
/**
 * @generated from protobuf message imports.GetAllImportsRequest
 */
export interface GetAllImportsRequest {
}
/**
 * @generated from protobuf message imports.GetAllImportsResponse
 */
export interface GetAllImportsResponse {
    /**
     * @generated from protobuf field: repeated imports.Import imports = 1
     */
    imports: Import[];
}
/**
 * @generated from protobuf message imports.DeleteImportRequest
 */
export interface DeleteImportRequest {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
}
/**
 * @generated from protobuf message imports.DeleteImportResponse
 */
export interface DeleteImportResponse {
    /**
     * @generated from protobuf field: uint32 deleted_transactions = 1
     */
    deletedTransactions: number;
    /**
     * @generated from protobuf field: uint32 reverted_transactions = 2
     */
    revertedTransactions: number;
}
/**
 * @generated from protobuf message imports.ImportProfile
 */
export interface ImportProfile {
    /**
     * @generated from protobuf field: uint32 account = 1
     */
    account: number;
    /**
     * @generated from protobuf field: string mapping = 2
     */
    mapping: string;
}
/**
 * @generated from protobuf message imports.GetAllImportProfilesRequest
 */
export interface GetAllImportProfilesRequest {
}
/**
 * @generated from protobuf message imports.GetAllImportProfilesResponse
 */
export interface GetAllImportProfilesResponse {
    /**
     * @generated from protobuf field: repeated imports.ImportProfile profiles = 1
     */
    profiles: ImportProfile[];
}
/**
 * @generated from protobuf message imports.SaveImportProfileRequest
 */
export interface SaveImportProfileRequest {
    /**
     * @generated from protobuf field: imports.ImportProfile profile = 1
     */
    profile?: ImportProfile;
}
/**
 * @generated from protobuf message imports.SaveImportProfileResponse
 */
export interface SaveImportProfileResponse {
}
/**
 * @generated from protobuf message imports.GetKnownFingerprintsRequest
 */
export interface GetKnownFingerprintsRequest {
    /**
     * @generated from protobuf field: uint32 account = 1
     */
    account: number;
    /**
     * @generated from protobuf field: repeated string fingerprints = 2
     */
    fingerprints: string[];
}
/**
 * @generated from protobuf message imports.KnownFingerprint
 */
export interface KnownFingerprint {
    /**
     * @generated from protobuf field: string fingerprint = 1
     */
    fingerprint: string;
    /**
     * @generated from protobuf field: uint32 transaction_id = 2
     */
    transactionId: number;
}
/**
 * @generated from protobuf message imports.GetKnownFingerprintsResponse
 */
export interface GetKnownFingerprintsResponse {
    /**
     * @generated from protobuf field: repeated imports.KnownFingerprint fingerprints = 1
     */
    fingerprints: KnownFingerprint[];
}
// @generated message type with reflection information, may provide speed optimized methods
class Import$Type extends MessageType<Import> {
    constructor() {
        super("imports.Import", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "account", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "file_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "row_count", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Import>): Import {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        message.account = 0;
        message.fileName = "";
        message.rowCount = 0;
        message.createdAt = "";
        if (value !== undefined)
            reflectionMergePartial<Import>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Import): Import {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                case /* uint32 account */ 2:
                    message.account = reader.uint32();
                    break;
                case /* string file_name */ 3:
                    message.fileName = reader.string();
                    break;
                case /* uint32 row_count */ 4:
                    message.rowCount = reader.uint32();
                    break;
                case /* string created_at */ 5:
                    message.createdAt = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Import, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        /* uint32 account = 2; */
        if (message.account !== 0)
            writer.tag(2, WireType.Varint).uint32(message.account);
        /* string file_name = 3; */
        if (message.fileName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.fileName);
        /* uint32 row_count = 4; */
        if (message.rowCount !== 0)
            writer.tag(4, WireType.Varint).uint32(message.rowCount);
        /* string created_at = 5; */
        if (message.createdAt !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.createdAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message imports.Import
 */
export const Import = new Import$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartImportRequest$Type extends MessageType<StartImportRequest> {
    constructor() {
        super("imports.StartImportRequest", [
            { no: 1, name: "account", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "file_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<StartImportRequest>): StartImportRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.account = 0;
        message.fileName = "";
        if (value !== undefined)
            reflectionMergePartial<StartImportRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StartImportRequest): StartImportRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 account */ 1:
                    message.account = reader.uint32();
                    break;
                case /* string file_name */ 2:
                    message.fileName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StartImportRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 account = 1; */
        if (message.account !== 0)
            writer.tag(1, WireType.Varint).uint32(message.account);
        /* string file_name = 2; */
        if (message.fileName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.fileName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message imports.StartImportRequest
 */
export const StartImportRequest = new StartImportRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartImportResponse$Type extends MessageType<StartImportResponse> {
    constructor() {
        super("imports.StartImportResponse", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<StartImportResponse>): StartImportResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial<StartImportResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StartImportResponse): StartImportResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StartImportResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message imports.StartImportResponse
 */
export const StartImportResponse = new StartImportResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllImportsRequest$Type extends MessageType<GetAllImportsRequest> {
    constructor() {
        super("imports.GetAllImportsRequest", []);
    }
    create(value?: PartialMessage<GetAllImportsRequest>): GetAllImportsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAllImportsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllImportsRequest): GetAllImportsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllImportsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message imports.GetAllImportsRequest
 */
export const GetAllImportsRequest = new GetAllImportsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllImportsResponse$Type extends MessageType<GetAllImportsResponse> {
    constructor() {
        super("imports.GetAllImportsResponse", [
            { no: 1, name: "imports", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Import }
        ]);
    }
    create(value?: PartialMessage<GetAllImportsResponse>): GetAllImportsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.imports = [];
        if (value !== undefined)
            reflectionMergePartial<GetAllImportsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllImportsResponse): GetAllImportsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated imports.Import imports */ 1:
                    message.imports.push(Import.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllImportsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated imports.Import imports = 1; */
        for (let i = 0; i < message.imports.length; i++)
            Import.internalBinaryWrite(message.imports[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message imports.GetAllImportsResponse
 */
export const GetAllImportsResponse = new GetAllImportsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteImportRequest$Type extends MessageType<DeleteImportRequest> {
    constructor() {
        super("imports.DeleteImportRequest", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteImportRequest>): DeleteImportRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial<DeleteImportRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteImportRequest): DeleteImportRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteImportRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message imports.DeleteImportRequest
 */
export const DeleteImportRequest = new DeleteImportRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteImportResponse$Type extends MessageType<DeleteImportResponse> {
    constructor() {
        super("imports.DeleteImportResponse", [
            { no: 1, name: "deleted_transactions", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "reverted_transactions", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteImportResponse>): DeleteImportResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.deletedTransactions = 0;
        message.revertedTransactions = 0;
        if (value !== undefined)
            reflectionMergePartial<DeleteImportResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteImportResponse): DeleteImportResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 deleted_transactions */ 1:
                    message.deletedTransactions = reader.uint32();
                    break;
                case /* uint32 reverted_transactions */ 2:
                    message.revertedTransactions = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteImportResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 deleted_transactions = 1; */
        if (message.deletedTransactions !== 0)
            writer.tag(1, WireType.Varint).uint32(message.deletedTransactions);
        /* uint32 reverted_transactions = 2; */
        if (message.revertedTransactions !== 0)
            writer.tag(2, WireType.Varint).uint32(message.revertedTransactions);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message imports.DeleteImportResponse
 */
export const DeleteImportResponse = new DeleteImportResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImportProfile$Type extends MessageType<ImportProfile> {
    constructor() {
        super("imports.ImportProfile", [
            { no: 1, name: "account", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "mapping", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ImportProfile>): ImportProfile {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.account = 0;
        message.mapping = "";
        if (value !== undefined)
            reflectionMergePartial<ImportProfile>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ImportProfile): ImportProfile {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 account */ 1:
                    message.account = reader.uint32();
                    break;
                case /* string mapping */ 2:
                    message.mapping = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ImportProfile, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 account = 1; */
        if (message.account !== 0)
            writer.tag(1, WireType.Varint).uint32(message.account);
        /* string mapping = 2; */
        if (message.mapping !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.mapping);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message imports.ImportProfile
 */
export const ImportProfile = new ImportProfile$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllImportProfilesRequest$Type extends MessageType<GetAllImportProfilesRequest> {
    constructor() {
        super("imports.GetAllImportProfilesRequest", []);
    }
    create(value?: PartialMessage<GetAllImportProfilesRequest>): GetAllImportProfilesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAllImportProfilesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllImportProfilesRequest): GetAllImportProfilesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllImportProfilesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message imports.GetAllImportProfilesRequest
 */
export const GetAllImportProfilesRequest = new GetAllImportProfilesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllImportProfilesResponse$Type extends MessageType<GetAllImportProfilesResponse> {
    constructor() {
        super("imports.GetAllImportProfilesResponse", [
            { no: 1, name: "profiles", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ImportProfile }
        ]);
    }
    create(value?: PartialMessage<GetAllImportProfilesResponse>): GetAllImportProfilesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.profiles = [];
        if (value !== undefined)
            reflectionMergePartial<GetAllImportProfilesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllImportProfilesResponse): GetAllImportProfilesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated imports.ImportProfile profiles */ 1:
                    message.profiles.push(ImportProfile.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllImportProfilesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated imports.ImportProfile profiles = 1; */
        for (let i = 0; i < message.profiles.length; i++)
            ImportProfile.internalBinaryWrite(message.profiles[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message imports.GetAllImportProfilesResponse
 */
export const GetAllImportProfilesResponse = new GetAllImportProfilesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SaveImportProfileRequest$Type extends MessageType<SaveImportProfileRequest> {
    constructor() {
        super("imports.SaveImportProfileRequest", [
            { no: 1, name: "profile", kind: "message", T: () => ImportProfile }
        ]);
    }
    create(value?: PartialMessage<SaveImportProfileRequest>): SaveImportProfileRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SaveImportProfileRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SaveImportProfileRequest): SaveImportProfileRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* imports.ImportProfile profile */ 1:
                    message.profile = ImportProfile.internalBinaryRead(reader, reader.uint32(), options, message.profile);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SaveImportProfileRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* imports.ImportProfile profile = 1; */
        if (message.profile)
            ImportProfile.internalBinaryWrite(message.profile, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message imports.SaveImportProfileRequest
 */
export const SaveImportProfileRequest = new SaveImportProfileRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SaveImportProfileResponse$Type extends MessageType<SaveImportProfileResponse> {
    constructor() {
        super("imports.SaveImportProfileResponse", []);
    }
    create(value?: PartialMessage<SaveImportProfileResponse>): SaveImportProfileResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SaveImportProfileResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SaveImportProfileResponse): SaveImportProfileResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SaveImportProfileResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message imports.SaveImportProfileResponse
 */
export const SaveImportProfileResponse = new SaveImportProfileResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetKnownFingerprintsRequest$Type extends MessageType<GetKnownFingerprintsRequest> {
    constructor() {
        super("imports.GetKnownFingerprintsRequest", [
            { no: 1, name: "account", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "fingerprints", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetKnownFingerprintsRequest>): GetKnownFingerprintsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.account = 0;
        message.fingerprints = [];
        if (value !== undefined)
            reflectionMergePartial<GetKnownFingerprintsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetKnownFingerprintsRequest): GetKnownFingerprintsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 account */ 1:
                    message.account = reader.uint32();
                    break;
                case /* repeated string fingerprints */ 2:
                    message.fingerprints.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetKnownFingerprintsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 account = 1; */
        if (message.account !== 0)
            writer.tag(1, WireType.Varint).uint32(message.account);
        /* repeated string fingerprints = 2; */
        for (let i = 0; i < message.fingerprints.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.fingerprints[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message imports.GetKnownFingerprintsRequest
 */
export const GetKnownFingerprintsRequest = new GetKnownFingerprintsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class KnownFingerprint$Type extends MessageType<KnownFingerprint> {
    constructor() {
        super("imports.KnownFingerprint", [
            { no: 1, name: "fingerprint", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "transaction_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<KnownFingerprint>): KnownFingerprint {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fingerprint = "";
        message.transactionId = 0;
        if (value !== undefined)
            reflectionMergePartial<KnownFingerprint>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: KnownFingerprint): KnownFingerprint {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string fingerprint */ 1:
                    message.fingerprint = reader.string();
                    break;
                case /* uint32 transaction_id */ 2:
                    message.transactionId = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: KnownFingerprint, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string fingerprint = 1; */
        if (message.fingerprint !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.fingerprint);
        /* uint32 transaction_id = 2; */
        if (message.transactionId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.transactionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message imports.KnownFingerprint
 */
export const KnownFingerprint = new KnownFingerprint$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetKnownFingerprintsResponse$Type extends MessageType<GetKnownFingerprintsResponse> {
    constructor() {
        super("imports.GetKnownFingerprintsResponse", [
            { no: 1, name: "fingerprints", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => KnownFingerprint }
        ]);
    }
    create(value?: PartialMessage<GetKnownFingerprintsResponse>): GetKnownFingerprintsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fingerprints = [];
        if (value !== undefined)
            reflectionMergePartial<GetKnownFingerprintsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetKnownFingerprintsResponse): GetKnownFingerprintsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated imports.KnownFingerprint fingerprints */ 1:
                    message.fingerprints.push(KnownFingerprint.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetKnownFingerprintsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated imports.KnownFingerprint fingerprints = 1; */
        for (let i = 0; i < message.fingerprints.length; i++)
            KnownFingerprint.internalBinaryWrite(message.fingerprints[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message imports.GetKnownFingerprintsResponse
 */
export const GetKnownFingerprintsResponse = new GetKnownFingerprintsResponse$Type();
/**
 * @generated ServiceType for protobuf service imports.ImportService
 */
export const ImportService = new ServiceType("imports.ImportService", [
    { name: "StartImport", options: {}, I: StartImportRequest, O: StartImportResponse },
    { name: "GetAllImports", options: {}, I: GetAllImportsRequest, O: GetAllImportsResponse },
    { name: "DeleteImport", options: {}, I: DeleteImportRequest, O: DeleteImportResponse },
    { name: "GetAllImportProfiles", options: {}, I: GetAllImportProfilesRequest, O: GetAllImportProfilesResponse },
    { name: "SaveImportProfile", options: {}, I: SaveImportProfileRequest, O: SaveImportProfileResponse },
    { name: "GetKnownFingerprints", options: {}, I: GetKnownFingerprintsRequest, O: GetKnownFingerprintsResponse }
]);
